import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./ForgotPassword.module.scss";
import axios from "axios";
import NavContext from "../../context/NavContext";
import Error from "../UiComponents/error/Error";
import Loader from "../UiComponents/loader/Loader";
import { MdOutlineArrowBack } from "react-icons/md";
import Success from "../UiComponents/sucess/Success";
import logo from "../../pics/logo-hearingspace.png";
import forgotImage from "../../pics/forgot-password.jpg";

const ForgotPassword = ({ showForgot, setShowForgot }) => {
  const { t } = useTranslation();
  const { loginUser, errorLogin, loaderLogin } = useContext(NavContext);

  const [userMail, setUserMail] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSucess] = useState(false);
  const [msgSuccess, setMsgSucess] = useState("");
  const [msgError, setmsgError] = useState("");

  axios.defaults.withCredentials = true;

  const submitFormsForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(`${process.env.REACT_APP_API_URL}api/sendEmailForNewPass`, {
        userMail: userMail,
      })
      .then(function (response) {
        // ✅ CHANGEMENT: on n'essaie plus de distinguer les cas (anti-énumération)
        // ✅ CHANGEMENT: on affiche le message générique renvoyé par l'API
        setSucess(true);
        setMsgSucess(
          response.data.message ||
            t("auth.reset_link_email_message")
        );
        setTimeout(() => setSucess(false), 2000);
        setLoading(false);
      })
      .catch(function (error) {
        // ✅ CHANGEMENT: même en erreur réseau, on reste neutre
        // (ça évite d'aider un attaquant + UX stable)
        setLoading(false);
        setSucess(true);
        setMsgSucess(
          t("auth.reset_link_email_message")
        );
        setTimeout(() => setSucess(false), 2000);
      });
  };

  return (
    <>
      <header className={styles.header}>
        <img src={logo} alt="Logo" className={styles.logo} />
      </header>

      <div className={styles.back_login} onClick={() => setShowForgot(false)}>
        <MdOutlineArrowBack style={{ fontSize: "25px" }} />
        <span>{t("auth.back_to_login")}</span>
      </div>

      <div className={styles.heroSection}>
        <div className={styles.leftSide}>
          <h1 className={styles.title}>{t("auth.forgot_password_title")}</h1>
          <form
            className={styles.loginForm}
            onSubmit={submitFormsForgotPassword}
          >
            <div className={styles.formGroup}>
              <label htmlFor="email">{t("login.email_label")}</label>
              <input
                type="text"
                id="email"
                placeholder={t("auth.email_placeholder_hs")}
                value={userMail}
                onChange={(e) => setUserMail(e.target.value)}
                required
              />
            </div>

            <button type="submit" className={styles.submitBtn}>
              {t("auth.reset_password_button")}
            </button>

            <p className={styles.linkEmail}>
              {t("auth.reset_link_email_message")}
            </p>

            {loading && <Loader />}
            {error && <Error error={msgError} />}
            {success && <Success success={msgSuccess} />}
          </form>
        </div>

        <div className={styles.rightSide}>
          <img
            src={forgotImage}
            alt={t("password_reset.forgot_password_alt")}
            className={styles.heroImage}
          />
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
